import { EventsCachedMesh } from "./EventsCachedMesh.js";
export class EventsDispatcher {
    _callbacks = {};
    _object3D;
    constructor(object3D) {
        this._object3D = object3D;
    }
    bind(eventName, eventCallback) {
        if (typeof eventName == "string") { //todo check opt togliendo instanceof ovunque
            this.bindSingle(eventName, eventCallback);
        }
        else {
            for (let event of eventName) {
                this.bindSingle(event, eventCallback);
            }
        }
    }
    bindSingle(eventName, eventCallback) {
        if (this._callbacks[eventName] && this._callbacks[eventName].length > 0) {
            this._callbacks[eventName].push(eventCallback);
        }
        else {
            this._callbacks[eventName] = [eventCallback];
            EventsCachedMesh.register(this._object3D, eventName);
        }
    }
    unbind(eventName, eventCallback) {
        if (typeof eventName == "string") {
            this.unbindSingle(eventName, eventCallback);
        }
        else {
            for (let event of eventName) {
                this.unbindSingle(event, eventCallback);
            }
        }
    }
    unbindSingle(eventName, eventCallback) {
        let event = this._callbacks[eventName];
        if (event) {
            let index = event.indexOf(eventCallback);
            if (index != -1) {
                event.splice(index, 1);
                if (event.length == 0) {
                    EventsCachedMesh.unregister(this._object3D, eventName);
                }
            }
        }
    }
    trigger(eventName, args) {
        let events = this._callbacks[eventName];
        if (events) {
            for (const event of events) {
                event(args);
            }
        }
        if (this._object3D.parent) {
            this._object3D.parent.triggerEvent(eventName, args);
        }
    }
    triggerWithoutPropagation(eventName, args) {
        let events = this._callbacks[eventName];
        if (events) {
            for (const event of events) {
                event(args);
            }
        }
    }
}
//# sourceMappingURL=EventsDispatcher.js.map